let {url} = require('sci/utils');

module.exports = function () {
    let args = Array.prototype.slice.call(arguments, 0, -1);
    return url(args.join(''));
};



// WEBPACK FOOTER //
// ./resources/assets/javascript/templates/url.js